import { createSelector } from 'reselect';

export const getBuildings = createSelector(
  (state) => state.buildings.data.buildings,
  (buildings) => {
    return buildings;
  }
);

export const getClients = createSelector(
  (state) => state.buildings.data.clients,
  (clients) => {
    return clients;
  }
);

export const getCurrentBuilding = createSelector(
  (state) => state.buildings.data.currentBuilding,
  (currentBuilding) => {
    return currentBuilding;
  }
);

export const getCurrentPage = createSelector(
  (state) => state.buildings.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getEngineerAdded = createSelector(
  (state) => state.buildings.ui.engineerAdded,
  (engineerAdded) => {
    return engineerAdded;
  }
);

export const getFiles = createSelector(
  (state) => state.buildings.ui.files,
  (files) => {
    return files;
  }
);

export const getForm = createSelector(
  (state) => state.buildings.ui.form,
  (form) => {
    return form;
  }
);

export const getInvalidFields = createSelector(
  (state) => state.buildings.ui.invalidFields,
  (invalidFields) => {
    return invalidFields;
  }
);

export const getParkingOnSite = createSelector(
  (state) => state.buildings.ui.parkingOnSite,
  (parkingOnSite) => {
    return parkingOnSite;
  }
);

export const getSelectedClientsId = createSelector(
  (state) => state.buildings.ui.selectedClientsId,
  (selectedClientsId) => {
    return selectedClientsId;
  }
);

export const getSelectedContractors = createSelector(
  (state) => state.buildings.ui.selectedContractors,
  (selectedContractors) => {
    return selectedContractors;
  }
);

export const getSelectedUnionsId = createSelector(
  (state) => state.buildings.ui.selectedUnionsId,
  (selectedUnionsId) => {
    return selectedUnionsId;
  }
);

export const getUnions = createSelector(
  (state) => state.buildings.data.unions,
  (unions) => {
    return unions;
  }
);

export const getValidationMessage = createSelector(
  (state) => state.buildings.ui.validationMessage,
  (validationMessage) => {
    return validationMessage;
  }
);

export const getWorkOrders = createSelector(
  (state) => state.buildings.data.workOrders,
  (workOrders) => {
    return workOrders;
  }
);

export const getProjects = createSelector(
  (state) => state.buildings.data.projects,
  (projects) => {
    return projects;
  }
);

export const getBuildingsCurrentPage = createSelector(
  (state) => state.buildings.ui.buildingsCurrentPage,
  (buildingsCurrentPage) => {
    return buildingsCurrentPage;
  }
);

export const getBuildingsTotal = createSelector(
  (state) => state.buildings.ui.buildingsTotal,
  (buildingsTotal) => {
    return buildingsTotal;
  }
);

export const getBuildingsPageSize = createSelector(
  (state) => state.buildings.ui.buildingsPageSize,
  (buildingsPageSize) => {
    return buildingsPageSize;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/buildings/buildings.js